
module.exports = {
  pathPrefix: '/',
  siteUrl: 'http://localhost:8000',
  siteTitle: 'Aravind Hande',
  siteDescription: 'Tech Blog of a software developer',
  author: 'Aravind Hande',
  postsForArchivePage: 3,
  defaultLanguage: 'en',
  disqusScript: 'https://Aravind-Hande.disqus.com/embed.js',
  pages: {
    home: '/',
    blog: 'blog',
    about: 'about',
    tag: 'tag',
    archive: 'archive'
  },
  social: {
    github: 'https://github.com/aravindhande',
    linkedin: '',
    rss: '/rss.xml'
  },
  tags: {
    angular: {
      description: 'Angular is an open source web application platform.'
    },
    babel: {
      description: 'Babel is a free and open-source JavaScript compiler that is mainly used to convert ECMAScript 2015+ code into a backwards compatible version of JavaScript that can be run by older JavaScript engines. Babel is popular tool for using the newest features of the JavaScript programming language.'
    },
    bootstrap: {
      description: 'Bootstrap is a free and open-source CSS framework directed at responsive, mobile-first front-end web development. It contains CSS- and JavaScript-based design templates for typography, forms, buttons, navigation and other interface components.'
    }, 
    contentful : {
      description: 'Contentful is the essential API-first content management infrastructure to create, manage and distribute content to any platform or device'
    },
    css: {
      name: 'CSS',
      description: 'Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language like HTML. CSS is a cornerstone technology of the World Wide Web, alongside HTML and JavaScript.'
    },
    django : {
      name: 'django',
      description: 'Django is a Python-based free and open-source web framework, which follows the model-template-view architectural pattern.'
    },
    electron: {
      description: 'Electron is a framework for building cross-platform desktop applications with web technology.'
    },
    efcore: {
      name: 'Entity Framework (EF) Core',
      description: 'Entity Framework Core is a lightweight and extensible version of the popular Entity Framework. Entity Framework is an object-relational mapper (O/RM) that enables .NET developers to work with a database using .NET objects. It eliminates the need for most of the data-access code that developers usually need to write.'
    },
    express: {
      description: 'Express.js, or simply Express, is a web application framework for Node.js, released as free and open-source software under the MIT License. It is designed for building web applications and APIs. It has been called the de facto standard server framework for Node.js.'
    },
    faker: {
      description: 'Faker is a JavaScript library which provides utility functions to generate massive amounts of realistic fake data in Node.js and the browser.'
    },
    firestore :{
      name: 'Cloud Firestore',
      description: 'Cloud Firestore is a cloud-hosted, NoSQL database that your iOS, Android, and web apps can access directly via native SDKs. Cloud Firestore is also available in native Node.js, Java, Python, and Go SDKs, in addition to REST and RPC APIs'
    },
    flask : {
      description: 'Flask is a micro web framework written in Python. It is classified as a microframework because it does not require particular tools or libraries. It has no database abstraction layer, form validation, or any other components where pre-existing third-party libraries provide common functions.'
    },
    gatsby: {
      description: 'Gatsby is a free and open source framework based on React and GraphQL that helps developers build blazing fast websites and apps'
    },
    graphql : {
      name: 'GraphQL',
      description: 'GraphQL is an open-source data query and manipulation language for APIs, and a runtime for fulfilling queries with existing data. GraphQL was developed internally by Facebook in 2012.'
    },
    grunt: {
      description: 'Grunt is a JavaScript task runner, a tool used to automatically perform frequent tasks such as minification, compilation, unit testing, and linting. It uses a command-line interface to run custom tasks defined in a file. Grunt was created by Ben Alman and is written in Node.js. It is distributed via npm.'
    },
    gulp: {
      name: 'Gulp.js',
      description: 'Gulp is an open-source JavaScript toolkit created by Eric Schoffstall used as a streaming build system in front-end web development.'
    },
    hapi: {
      description: 'hapi is a simple to use configuration-centric framework with built-in support for input validation, caching, authentication, and other essential facilities for building web and services applications. hapi enables developers to focus on writing reusable application logic in a highly modular and prescriptive approach.'
    },
    javascript: {
      description: 'JavaScript is an object-oriented programming language used alongside HTML and CSS to give functionality to web pages.'
    },
    jquery: {
      name: 'jQuery',
      description: 'jQuery is a JavaScript library designed to simplify HTML DOM tree traversal and manipulation, as well as event handling, CSS animation, and Ajax. '
    },
    json: {
      name: 'JSON',
      description: 'In computing, JavaScript Object Notation is an open-standard file format that uses human-readable text to transmit data objects consisting of attribute–value pairs and array data types. It is a very common data format, with a diverse range of applications, such as serving as replacement for XML in AJAX systems.'
    },
    laravel: {
      description: 'Laravel is a PHP framework for building web applications following the MVC pattern.'
    },
    lodash: {
      description: 'Lodash is a JavaScript library which provides utility functions for common programming tasks using the functional programming paradigm.'
    },
    mean: {
      name: 'MEAN',
      description: 'The acronym “MEAN” stands for “MongoDB Express.js Angular Node.js”'
    },
    mern: {
      name: 'MERN',
      description: 'The acronym “MERN” stands for “MongoDB Express.js React.js Node.js”'
    },
    mevn: {
      name: 'MEVN',
      description: 'The acronym “MEVN” stands for “MongoDB Express.js VueJS Node.js”. A MEVN stack is a nice little alternative to MEAN and MERN stacks which use Angular and React as their frontends, respectively.'
    },
    mongodb: {
      name: 'MongoDB',
      description: 'MongoDB is a cross-platform document-oriented database program. Classified as a NoSQL database program, MongoDB uses JSON-like documents with schema.'
    },
    mongoose: {
      description: 'Mongoose is a MongoDB object modeling tool designed to work in an asynchronous environment.'
    },
    mysql : {
      name: 'MySQL',
      description: 'MySQL is an open-source relational database management system.'
    },
    nextjs :{
      name: 'Next.js',
      description: 'Next.js is a free and open source web application framework based on React.js, Node.js, Webpack and Babel.js. Use Next.js to build server-rendered applications, static websites, and more'
    },
    nodejs: {
      name: 'Node.js',
      description: 'Node.js is a tool for executing JavaScript in a variety of environments.'
    },
    nosql: {
      name: 'NoSQL',
      description: 'NoSQL databases (additionally called Not Only SQL Databases) are non-relational database systems used for storing and retrieving data. There are many types of NoSQL databases -- document databases (MongoDB), key-value stores (Redis), wide-column stores (Cassandra), Graph Stores (Neo4j)'
    },
    nuxtjs: {
      name: 'Nuxt.js',
      description: 'Nuxt.js is a free and open source web application framework based on Vue.js, Node.js, Webpack and Babel.js. The framework is advertised as "meta-framework for universal applications".'
    },
    odata: {
      name: 'OData',
      description: 'OData (Open Data Protocol) is an ISO/IEC approved, OASIS standard that defines a set of best practices for building and consuming RESTful APIs. OData helps you focus on your business logic while building RESTful APIs without having to worry about the various approaches to define request and response headers, status codes, HTTP methods, URL conventions, media types, payload formats, query options, etc. OData also provides guidance for tracking changes, defining functions/actions for reusable procedures, and sending asynchronous/batch requests.'
    },
    npm: {
      name: 'NPM',
      description: 'npm is a package manager for the JavaScript programming language. It is the default package manager for the JavaScript runtime environment Node.js. It consists of a command line client, also called npm, and an online database of public and paid-for private packages, called the npm registry. '
    },
    postgresql: {
      name: 'PostgreSQL', 
      description: 'PostgreSQL also known as Postgres, is a free and open-source relational database management system emphasizing extensibility and technical standards compliance.'
    },
    python: {
      description: "Python is an interpreted, high-level, general-purpose programming language. Created by Guido van Rossum and first released in 1991, Python's design philosophy emphasizes code readability with its notable use of significant whitespace."
    },
    puppeteer: {
      description: 'Puppeteer is a Node library which provides a high-level API to control headless Chrome or Chromium over the DevTools Protocol. It can also be configured to use full (non-headless) Chrome or Chromium.'
    },
    react: {
      description: 'React is an open source JavaScript library used for designing user interfaces.'
    },
    redis: {
      description: 'Redis is an in-memory data structure project implementing a distributed, in-memory key-value database with optional durability. Redis supports different kinds of abstract data structures, such as strings, lists, maps, sets, sorted sets, HyperLogLogs, bitmaps, streams, and spatial indexes.'
    },
    redux: {
      description: "Redux is an open-source JavaScript library for managing application state. It is most commonly used with libraries such as React or Angular for building user interfaces. Similar to Facebook's Flux architecture, it was created by Dan Abramov and Andrew Clark."
    },
    restapi: {
      name: 'RESTful API',
      description: 'A RESTful API is an application program interface (API) that uses HTTP requests to GET, PUT, POST and DELETE data. A RESTful API -- also referred to as a RESTful web service -- is based on representational state transfer (REST) technology, an architectural style and approach to communications often used in web services development'
    },
    rxjs: {
      name: 'RxJS',
      description: 'RxJS is a library for reactive programming using Observables, to make it easier to compose asynchronous or callback-based code.'
    },
    sass: {
      description: 'Sass is a stable extension to classic CSS. Sass is a style sheet language initially designed by Hampton Catlin and developed by Natalie Weizenbaum. After its initial versions, Weizenbaum and Chris Eppstein have continued to extend Sass with SassScript, a simple scripting language used in Sass files. '
    },
    scrapy: {
      description: 'Scrapy is a free and open-source web-crawling framework written in Python. Originally designed for web scraping, it can also be used to extract data using APIs or as a general-purpose web crawler.'
    },
    scraping: {
      name: 'Web Scraping',
      description: 'Web scraping, web harvesting, or web data extraction is data scraping used for extracting data from websites. Web scraping software may access the World Wide Web directly using the Hypertext Transfer Protocol, or through a web browser.'
    },
    selenium: {
      description: 'Selenium automates browsers. Primarily, it is for automating web applications for testing purposes, but is certainly not limited to just that.'
    },
    sequelize: {
      description: 'Sequelize is a promise-based Node.js ORM for Postgres, MySQL, MariaDB, SQLite and Microsoft SQL Server. It features solid transaction support, relations, eager and lazy loading, read replication and more.'
    },
    sql: {
      name: 'SQL Server',
      description: 'Microsoft SQL Server is a relational database management system developed by Microsoft.'
    },
    sqlite: {
      name: 'SQLite',
      description: 'SQLite is a relational database management system contained in a C library. In contrast to many other database management systems, SQLite is not a client–server database engine. Rather, it is embedded into the end program. '
    },
    typescript: {
      description: 'TypeScript is a typed superset of JavaScript that compiles to plain JavaScript.'
    },
    vuejs: {
      name: 'Vue.js',
      description: 'Vue.js is a JavaScript framework for building interactive web applications.'
    },
    webpack: {
      description: 'Webpack is an open-source JavaScript module bundler. It is a module bundler primarily for JavaScript, but it can transform front-end assets like HTML, CSS, and images if the corresponding plugins are included. Webpack takes modules with dependencies and generates static assets representing those modules. '
    },
    yarn: {
      description: 'Yarn is a new package manager that replaces the existing workflow for the npm client or other package managers while remaining compatible with the npm registry.'
    }
  }
}